var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartBarSolidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2V14H14.5V2H10.5ZM11.5 3H13.5V13H11.5V3ZM1.5 5V14H5.5V5H1.5ZM2.5 6H4.5V13H2.5V6ZM6 8V14H10V8H6ZM7 9H9V13H7V9Z",
    fill: "#303335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBarSolidIcon);
export default __webpack_public_path__ + "static/media/chartBarSolidIcon.17801765b74d3dbeb3a54e59dd46c4dc.svg";
export { ForwardRef as ReactComponent };